import { SectionFourDocTypeTypes } from "../types/documents-four-enum";

export const uploadConfigMultiFour = [
  {
    title: "Исполнительная схема",
    docType: SectionFourDocTypeTypes.BUILT_SCHEME,
  },
  {
    title: "Исполнительный чертеж",
    docType: SectionFourDocTypeTypes.BUILT_BLUEPRINT,
  },
  {
    title: "Лабораторные документы",
    docType: SectionFourDocTypeTypes.LABORATORYDATA_DOC,
  },
  {
    title: "Иные документы",
    docType: SectionFourDocTypeTypes.SUPPORTING_DOC,
  },
];
